import React, { useState } from "react";
import { ChiTietTaiSan1 } from "./ChiTiet/ChiTietTaiSan";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import ChiTietHopDong from "service/chiTietHopDongApi";
export const BtnChiTietHopDong = ({ taisan }) => {
  const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
  const handleCloseChiTietHopDong = () => setShowChiTietHopDong(false);
  const handleShowChiTietHopDong = () => setShowChiTietHopDong(true);

  const objChiTietHopDong = {};
  const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);

  const timkiemHopDong = { choVayId: 0 };

  const functionChiTietChoVay = () => {
    console.log(timkiemHopDong);
    timkiemHopDong.choVayId = taisan.ChoVayID;
    // ChiTietHopDong.getChiTietHopDong1(taisan.ChoVayID).then((response) => {
    //   setChoVay(response.data);
    //   setShowChiTietHopDong(true);
    // });

    if (taisan.IdChoVay != null && taisan.IdChoVay != undefined) {
      ChiTietHopDong.getChiTietHopDong1(taisan.ChoVayID).then((response) => {
        setChoVay(response.data);
        setShowChiTietHopDong(true);
      });
    } else {
      ChiTietHopDong.getChiTietHopDong(taisan.IdNhanVay, 2).then(
        (response) => {
          setChoVay(response.data);
          setShowChiTietHopDong(true);
        }
      );
    }
  };

  return (
    <>
      <a
        onClick={functionChiTietChoVay}
        href={() => false}
        className="blue word-break btn-link"
      >
        {taisan.MaHopDong}
      </a>
      {showChiTietHopDong && (
        <ChiTietHopDongContainer
          show={handleShowChiTietHopDong}
          onHide={handleCloseChiTietHopDong}
          data={chovayChiTiet}
          setModalTaiSan={handleShowChiTietHopDong}
        ></ChiTietHopDongContainer>
      )}
    </>
  );
};
